<template>
    <div class="widget-item widget-triple-chart">
        <a v-if="!editDisabled  && !chartData.required && $parent.createMode" class="remove-widget" @click.prevent="$parent.removeWidget(chartData.id);"><i class="fa fa-times"></i></a>
        <div class="title">
            {{this.chartData.title}}
        </div>
        <div v-if="chartData.type != 'progress'" class="clearfix">
            <div class="chart-container" v-for="(chart, index) in chartData.data">
                <p class="chart-label">{{chart.labels[0]}}</p>
                <div><canvas :id="'chart_triple_'+index"></canvas></div>
            </div>
        </div>
        <div v-else class="clearfix">
            <div class="chart-container" v-for="(progress, index) in chartData.data">
                <p class="chart-label">{{progress.title}}</p>
                <p class="chart-value">{{progress.percentage}}%</p>
                <div class="meter" :class="'meter' + index">
                  <span class="progress-meter" :style="{'width': progress.percentage+'%'}"></span>
                </div>
            </div>
        </div>
    </div>
</template>

<script type="text/javascript">
    var base_url = window.location.protocol + "//" + window.location.host

    import Vue from 'vue';
    import VueEvents from 'vue-events'
    import axios from 'axios'

    Vue.use(VueEvents)

    export default {
        name: 'widget-triple-chart',
        props: [
            'chartData',
            'chartId',
            'editDisabled',
        ],
        mounted() {
            if (this.chartData.type != 'progress') {
                setTimeout(function(){
                    this.chartData.data.forEach(function(chartData, index) {
                        let chartId = 'chart_triple_'+index;
                        this.createChart(chartId, chartData);
                    }.bind(this));
                }.bind(this), 100);
            }
        },
        methods: {
            createChart(chartId, chartData) {
                var ctx = document.getElementById(chartId);
                var myChart = new Chart(ctx, {
                    type: 'doughnut',
                    data: chartData,
                    options: {
                        responsive: true,
                    }
                });
            },
        }
    };
</script>

<style scoped="" lang="scss">
meter { -webkit-appearance: none; }
.widget-triple-chart{
    padding: 15px 20px!important;
    .title{
        font-size: 20px;
        color: #7D7D7D;
        text-align: center;
        margin-bottom: 20px;
        margin-right: 19px;
        padding: 0px 5px;
    }
    .chart-container{
        float: left;
        width: 33.33%;
        padding:10px;
    }
    &.pie{
        // Add Pie Chart Styling
    }
    .chart-label{
        font-size: 14px;
        color: #9B9B9B;
        font-weight: 400 ;
        text-align: center;
    }
    .chart-value{
        font-size: 30px;
        color: #1F2529;
        letter-spacing: 0;
        text-align: center;
        margin-bottom:20px;
    }
    .meter{
        height: 5px;
        position: relative;
        background: #F0F1F1;
        border-radius: 5px;
        .progress-meter{
            display: block;
            height: 100%;
            border-radius:5px;
            background-color: #00AFD7;
        }
        &.meter0{
            .progress-meter{
                background-color: #AB5755;
            }
        }
        &.meter1{
            .progress-meter{
                background-color: #E7A33F;
            }
        }
        &.meter2{
            .progress-meter{
                background-color: #3CAA9E;
            }
        }
    }
}
</style>
